import { ReactNode } from 'react';
import { Typography } from '@mui/material';

export interface RawJsonEditorProps {
    text: string;
    error: string;
    onTextChange: (text: string) => void;
    onBlur: () => void;
    actions?: ReactNode;
}

export const RawJsonEditor = ({ text, error, onTextChange, onBlur, actions }: RawJsonEditorProps) => (
    <div className="app-sf-json">
        <textarea
            className="app-sf-json-textarea"
            aria-label="Raw JSON editor"
            value={text}
            rows={12}
            onChange={(e) => onTextChange(e.target.value)}
            onBlur={onBlur}
        />
        {error ? (
            <Typography variant="body2" color="error" sx={{ whiteSpace: 'pre-wrap', mt: 1 }}>
                {error}
            </Typography>
        ) : null}
        {actions ? <div className="app-sf-json-actions">{actions}</div> : null}
    </div>
);
